import React from 'react';
import PropTypes from 'prop-types';
import {Popover, PopoverBody} from 'reactstrap';

import {oeInterfaceManager} from '../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../react-oe/oe-interface-adapter';
import OEColor from '../color-picker/oe-color';
import OEColorHelper from '../../lib/color/oe-color-helper';
import OEStyleSheetTool from '../../lib/tools/oe-style-sheet-tool';
import {oeUniqueIdGen} from '../../lib/tools/oe-unique-id-gen';
import {OEBackdrop} from '../../lib/components/oe-window';
import retardUpdate from '../../lib/react/update-retarder';
import OEToolbox from '../../lib/tools/oe-toolbox';
import OEWidgetHeader from '../elements/oe-widget-header';
import OEDraggable from './oe-draggable';

export default class OEPopover extends React.PureComponent {

    constructor(props) {
        super(props);

        this.uid = oeUniqueIdGen.get();

        if(this.props.moduleId) this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.uiControllerType = typeof(this.props.uiControllerType) === 'number' ? this.props.uiControllerType : null;

        this.pinned = true;

        this.position = {x: 0, y: 0};

        this.state = Object.assign({
            isOpen:                 false,
            uiControllerType:       this.uiControllerType,
            pinned:                 this.pinned,
            position:               {...this.position},
            draggableHandleId:      'popover-draggable-handle-id-' + this.uid
        }, this.getColorState());

        this.onLayoutChanged = this.onLayoutChanged.bind(this);

        this.onBgColorChanged = this.onBgColorChanged.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);

        this.onColorModelChanged = this.onColorModelChanged.bind(this);

        this.onPopoverTagRef = this.onPopoverTagRef.bind(this);
        this.onPopoverPosRef = this.onPopoverPosRef.bind(this);
        this.onPopoverPinRef = this.onPopoverPinRef.bind(this);
        this.onBackdropElementRef = this.onBackdropElementRef.bind(this);

        this.onDraggablePositionChanged = this.onDraggablePositionChanged.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.onPinBtnPressed = this.onPinBtnPressed.bind(this);
    }

    setUIControllerType(uiControllerType)   {
        let uiControllerType_ = uiControllerType;
        if(typeof(uiControllerType_) === 'object')    {
            uiControllerType_ = uiControllerType_ === null ? uiControllerType_ : uiControllerType_.value;
        }
        if(uiControllerType_ !== null && typeof(uiControllerType_) !== 'number')    return;
        if(this.uiControllerType === uiControllerType_) return;
        this.uiControllerType = uiControllerType_;
        this.setState({uiControllerType: this.uiControllerType});
        this.updateUIController();
    }

    getPinned() {
        return this.pinned;
    }

    setPinned(pinned)   {
        if(this.pinned === pinned)  return;
        this.pinned = pinned;
        this.setState({pinned: this.pinned});
        if(this.props.onPinnedChanged)  this.props.onPinnedChanged(this, this.pinned);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.uiControllerType !== this.props.uiControllerType)     {
            let isOpenPrev = this.isOpen();
            this.setUIControllerType(nextProps.uiControllerType);
            if(isOpenPrev !== this.isOpen()) this.onIsOpenStateChanged();
        }

        if(nextProps.unpinnable !== this.props.unpinnable && !nextProps.unpinnable)     {
            this.setPinned(true);
        }
    }

    componentDidMount()    {
        this.onColorModelChanged();
        window.addEventListener('oe-layout-changed', this.onLayoutChanged);
        OEColorHelper.registerModelChangeListener(this.onColorModelChanged);
    }

    componentWillUnmount()    {
        window.removeEventListener('oe-layout-changed', this.onLayoutChanged);
        OEColorHelper.unregisterModelChangeListener(this.onColorModelChanged);
    }

    componentDidUpdate(prevProps, prevState)    {
        let isOpenPrev = prevState.uiControllerType !== null ? prevState.isOpen : prevProps.isOpen;
        if(isOpenPrev !== this.isOpen()) this.onIsOpenStateChanged();
    }

    isOpen()    {
        return this.state.uiControllerType !== null ? this.state.isOpen : this.props.isOpen;
    }

    onIsOpenStateChanged()  {
        if(this.props.onIsOpenStateChanged) this.props.onIsOpenStateChanged(this, this.isOpen());
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.bgColorChanged, this.onBgColorChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.bgColorChanged, this.onBgColorChanged);
    }

    updateUIController()  {
        if(this.uiControllerType === null || !this.oe || !this.oe.isReady())   return;
        this.setState({isOpen: this.oe.sharedInterface.getUIControllerVisible({value: this.uiControllerType})});
    }

    getColorState(brightness)   {
        brightness = typeof(brightness) === 'number' ? brightness : (this.oe && this.oe.isReady() ? this.oe.sharedInterface.getUIControllerColorTheme().getBackgroundColorBrightness() : OEStyleSheetTool.brightness);

        let bgColor = OEColorHelper.stdBackgroundColor(brightness);
        let textColor = OEColorHelper.stdLabelTextColor(brightness);

        let strBgColor = OEColor.toDOMStr(bgColor);
        let strTextColor = OEColor.toDOMStr(textColor);

        let ret = {
            bgColor:                bgColor,
            textColor:              textColor,
            strBgColor:             strBgColor,
            strTextColor:           strTextColor,
            popperModifiers: {
                styling: {
                    enabled: true,
                    fn: function(data, options) {
                        data.styles.backgroundColor     = strBgColor;
                        data.styles.color               = strTextColor;
                        data.styles.borderRightColor    = strBgColor;
                        data.styles.borderLeftColor     = strBgColor;
                        data.styles.borderTopColor      = strBgColor;
                        data.styles.borderBottomColor   = strBgColor;
                        // arrowStyles are ignored by react-popper :(
                        // workaround -> inherit borderRightColor style in custom style sheets for arrow, see .popover .arrow in styles.css
                        //data.arrowStyles.borderRightColor = strBgColor;
                        return data;
                    },
                    order: 850
                }
            }
        };

        return ret;
    }

    updateColors(brightness)  {
        let colorState = this.getColorState(brightness);

        this.setState(colorState);

        // we set the background color and text color
        if(this.tagElement != null && this.tagElement.parentNode != null && this.tagElement.parentNode.parentNode != null)  {
            this.tagElement.parentNode.parentNode.style.backgroundColor = colorState.strBgColor;
            this.tagElement.parentNode.parentNode.style.color = colorState.strTextColor;
            this.tagElement.parentNode.parentNode.style.borderRightColor = colorState.strBgColor;
        }
    }

    updateState(released)   {
        if(!this.oe || !this.oe.isReady() || released)   {
            this.setState({isOpen: false});
            return;
        }

        retardUpdate(this, () => {
            this.updateUIController();
            this.updateColors();
        });
    }

    onLayoutChanged()   {
        if(!this.isOpen())  return;
        this.forceUpdate();
    }

    onBgColorChanged(message, userInfo)  {
        this.updateColors(userInfo.brightness);
    }

    onUIControllerStateChanged(message, userInfo)   {
        if(userInfo.type.value === this.uiControllerType)   {
            this.setState({isOpen: userInfo.visible});
        }
    }

    onColorModelChanged()   {
        this.updateColors();
    }

    onPopoverTagRef(ref)  {
        this.tagElement = ref;
        this.updateColors();
    }

    onPopoverPosRef(ref)   {
        this.posRef = ref;
    }

    onPopoverPinRef(ref)  {
        this.setState({hasTarget: ref ? true : false});
    }

    onBackdropElementRef(ref)  {
        this.setState({hasBackdrop: ref ? true : false});
    }

    renderContent() {
        return (
            <React.Fragment>
                <div id={this.props.popoverTargetId} className="popover-target" ref={this.props.onPopoverTargetRef} />
                <div className="popover-pos-ref" ref={this.onPopoverPosRef} />

                {this.props.noHeader ? null :
                    <OEWidgetHeader
                        {...this.props}
                        className="popover-header"
                        draggableHandleElementId={this.state.draggableHandleId}
                        uiControllerType={this.state.uiControllerType}
                        pinned={this.state.pinned}
                        onToggle={this.onToggle}
                        onPinBtnPressed={this.props.unpinnable ? this.onPinBtnPressed : null}
                    />
                }

                <PopoverBody>{this.props.children}</PopoverBody>
            </React.Fragment>
        );
    }

    renderPinned() {
        let isOpen = this.isOpen();

        let explicitePosition = this.props.position || this.props.rect;

        let target = !explicitePosition ? this.props.target : ('target-id-' + this.uid);

        if(!target) return null;

        /*
        Setting the key prop to target is a workaround to get the Popover updated for target prop changes.
        That it is not updated automatically for target changes, seems to a bug in the Reactstrap Popover implementation.
        The workaround has to be enabled explicitly with the targetReplacementWorkaround prop to prevent unexpected side effects in components that don't need this fix.
        */

        let popover = !target || (explicitePosition && !this.state.hasTarget) ? null : (
            <Popover
                key={this.props.targetReplacementWorkaround && typeof(target) === 'string' ? target : undefined}
                className={'pinned ' + this.props.className + (this.props.hideArrow ? ' hide-arrow' : '') + (this.props.backdrop ? ' with-backdrop' : '') + (this.props.noHeader ? ' no-header' : '')}
                placement={this.props.placement}
                isOpen={isOpen}
                boundariesElement={this.props.boundariesElement}
                target={target}
                modifiers={this.state.popperModifiers}
                hideArrow={this.props.hideArrow}
                offset={this.props.offset}
                innerRef={this.props.onContentRef}
            >
                <div ref={this.onPopoverTagRef} />

                {this.renderContent()}
            </Popover>
        );

        if(explicitePosition)   {
            let rect = this.props.rect;
            let pos = !rect ? this.props.position : {x: rect.x, y: rect.y}; 
            let style = {left: typeof(pos.x) === 'string' ? pos.x : (pos.x.toString() + 'px'), top: typeof(pos.y) === 'string' ? pos.y : (pos.y.toString() + 'px')};

            if(rect)    {
                style.width = typeof(rect.w) === 'string' ? rect.w : (rect.w.toString() + 'px');
                style.height = typeof(rect.h) === 'string' ? rect.h : (rect.h.toString() + 'px');
            }

            popover = (
                <div id={target} className="popover-pin" style={style} ref={this.onPopoverPinRef}>
                    {popover}
                </div>
            );
        }

        if(this.props.backdrop && isOpen) {
            // popover insertion only if backdrop has been mounted is a trick to ensure that the backdrop is injected into the DOM in front of the popover
            popover = (
                <React.Fragment>
                    <OEBackdrop enabled={true} onClick={this.onToggle} options={this.props.backdropOptions} elementRef={this.onBackdropElementRef}/>
                    {!this.state.hasBackdrop ? null : popover}
                </React.Fragment>
            );
        }

        return popover;
    }

    renderUnpinned()    {
        let isOpen = this.isOpen();

        let draggable = (
            <OEDraggable
                className={'popover unpinned std-bg std-label-text-color ' + this.props.className + (this.props.backdrop ? ' with-backdrop' : '') + (this.props.noHeader ? ' no-header' : '')}
                hide={!isOpen}
                handle={'#' + this.state.draggableHandleId}
                position={this.state.position}
                onPositionChanged={this.onDraggablePositionChanged}
                onContentRef={this.props.onContentRef}
            >
                 {this.renderContent()}
            </OEDraggable>
        );

        if(this.props.backdrop && isOpen) {
            // popover insertion only if backdrop has been mounted is a trick to ensure that the backdrop is injected into the DOM in front of the popover
            draggable = (
                <React.Fragment>
                    <OEBackdrop enabled={true} onClick={this.onToggle} options={this.props.backdropOptions} elementRef={this.onBackdropElementRef}/>
                    {!this.state.hasBackdrop ? null : draggable}
                </React.Fragment>
            );
        }

        return draggable;
    }

    render() {
        return (
            <React.Fragment>
                {this.props.moduleId ? <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/> : null}
                {this.state.pinned ? this.renderPinned() : this.renderUnpinned()}
            </React.Fragment>
        );
    }

    onDraggablePositionChanged(sender, position)    {
        if(OEToolbox.shallowEqual(this.position, position))    return;
        this.position = {...position};
        this.setState({position: {...this.position}});
    }

    onToggle() {
        if(this.props.onToggle)    this.props.onToggle(this);

        if(this.uiControllerType === null || !this.oe || !this.oe.isReady()) return;
        this.oe.sharedInterface.setUIControllerVisible(false, {value: this.uiControllerType});
    }

    onPinBtnPressed()   {
        if(this.state.pinned && this.posRef)   {
            let rect = this.posRef.getBoundingClientRect();
            this.position = {x: rect.left, y: rect.top};
            this.setState({position: {...this.position}});
        }

        this.setPinned(!this.getPinned());
    }
}

OEPopover.defaultProps = {
    className:                      '',
    placement:                      'auto',
    position:                       null,
    rect:                           null,
    hideArrow:                      false,
    noHeader:                       false,
    buttonClassName :               '',
    headerSeparator:                true,
    isOpen:                         false,
    unpinnable:                     false,
    backdrop:                       false,
    backdropOptions:                {color: 'rgba(0, 0, 0, 0.2)', animated: true, duration: 0.333},
    targetReplacementWorkaround:    false
};

OEPopover.propTypes = {
    className:                      PropTypes.string,
    moduleId:                       PropTypes.string,
    uiControllerType:               PropTypes.number,
    placement:                      PropTypes.string,
    position:                       PropTypes.shape({x: PropTypes.number, y: PropTypes.number}),
    rect:                           PropTypes.shape({x: PropTypes.number, y: PropTypes.number, w: PropTypes.number, h: PropTypes.number}),
    hideArrow:                      PropTypes.bool,
    noHeader:                       PropTypes.bool,
    offset:                         PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    buttonClassName:                PropTypes.string,
    headerSeparator:                PropTypes.bool,
    renderHeader:                   PropTypes.func,
    additionalButtons:              PropTypes.func,
    centerBar:                      PropTypes.func,
    isOpen:                         PropTypes.bool,
    icon:                           PropTypes.string,
    title:                          PropTypes.string,
    titleId:                        PropTypes.string,
    unpinnable:                     PropTypes.bool,
    backdrop:                       PropTypes.bool,
    backdropOptions:                PropTypes.shape({color: PropTypes.string, animated: PropTypes.bool, duration: PropTypes.number}),
    targetReplacementWorkaround:    PropTypes.bool,      /* Enabled a workaround to get placement updates working when the target prop changes. See also the comment in renderPinned. */
    onIsOpenStateChanged:           PropTypes.func,
    onToggle:                       PropTypes.func,
    onHelpBtnPressed:               PropTypes.func,
    onPinnedChanged:                PropTypes.func,
    popoverTargetId:                PropTypes.string,
    onContentRef:                   PropTypes.func,
    onPopoverTargetRef:             PropTypes.func,
};

//
OEPopover.coat = function(WrappedComponent, popoverOverrideProps, defaultProps, propTypes, baseClassName = 'popover-control') {

    let popoverPropKeys = Object.keys(OEPopover.propTypes);
    popoverPropKeys.push('uiControllerType', 'boundariesElement', 'target');

    let wrappedComponentPropKeys = Object.keys(WrappedComponent.propTypes).filter(key => key !== 'className');
    wrappedComponentPropKeys.push('uiControllerType', 'placement', 'boundariesElement', 'appComponent', 'children');

    baseClassName = typeof(baseClassName) === 'string' ? baseClassName + ' ' : '';

    let popover = class extends React.PureComponent {

        constructor(props)  {
            super(props);
    
            this.popoverTargetId = 'popover-target-id-' + oeUniqueIdGen.get();
        }

        render() {
            let popoverProps = OEToolbox.filterObject(this.props, popoverPropKeys);
            let wrappedProps = Object.assign({}, OEToolbox.filterObject(this.props, null, popoverPropKeys), OEToolbox.filterObject(this.props, wrappedComponentPropKeys));
            const {className, ...restPopoverProps} = popoverProps;
            const {controllerClassName, ...restWrappedProps} = wrappedProps;

            return  (
                <OEPopover
                    className={baseClassName + className}
                    popoverTargetId={this.popoverTargetId}
                    {...restPopoverProps}
                    {...popoverOverrideProps}
                >
                    <WrappedComponent
                        className={controllerClassName}
                        popoverTargetId={this.popoverTargetId}
                        {...restWrappedProps}
                    />
                </OEPopover>
            );
        }
    };

    let wrappedClassNameDefaultProp =  WrappedComponent.defaultProps.className;
    let wrappedClassNamePropType =  WrappedComponent.propTypes.className;

    let wrappedDefaultProps = OEToolbox.filterObject(WrappedComponent.defaultProps, null, ['className']);
    let wrappedDefaultPropTypes = OEToolbox.filterObject(WrappedComponent.propTypes, null, ['className']);

    popover.defaultProps = Object.assign({}, OEPopover.defaultProps, wrappedDefaultProps, {controllerClassName: wrappedClassNameDefaultProp}, defaultProps);
    popover.propTypes = Object.assign({}, OEPopover.propTypes, wrappedDefaultPropTypes, {controllerClassName: wrappedClassNamePropType}, propTypes);

    return popover;
};